import React, {ChangeEvent} from "react";
import _uniqueId from "lodash/uniqueId";
import Utilities from "@util/Utilities";

type Props = {
    isRequired?: boolean,
    form?: any,
    name: string,
    label?: string,
    value?: any,
    labelExtraClassName?: string,
    className?: string,
    disabled?: boolean
    readonly?: boolean,
    onClick?:()=>any,
    onChange?:(event:ChangeEvent)=>any
}

const FormCheckbox: React.FunctionComponent<Props> = (
    {
        isRequired,
        form,
        name,
        label,
        className,
        labelExtraClassName,
        value,
        disabled,
        readonly,
        onClick,
        onChange
    }
) => {

    const uniqueId = _uniqueId('input-');

    return <div className="flex items-center">
        <input
            id={uniqueId}
            {...form.register(name, {required: isRequired})}
            type="checkbox"
            value={value}
            readOnly={readonly}
            disabled={disabled}
            onClick={onClick}
            onChange={onChange}
            className={Utilities.classNames(
                !!className ? className : "input-checkbox")}
        />
        <label htmlFor={uniqueId} className={Utilities.classNames("ml-2 label", labelExtraClassName??'-')}>
            {label}
        </label>
    </div>
}

export default FormCheckbox;